<template>
    <div>
        <limitless-page-header :title="'Skördeplaner'" :buttons="[{'url':'/harvestplans/0','text':'New plan', 'icon':'icon-plus-circle2'}]"></limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/harvestplans/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control">
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import RednaxDatatable from '@components/RednaxDatatableComponent';

export default {
    name: 'HarvestPlanList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
            },
            {
                header: 'Enhet',
                data: 'unit_name',
                sortable: true,
            },
            {
                header: 'Gäller fr.o.m.',
                data: 'start_date',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row) {
            window.location.href = '/harvestplans/' + row.id;
        },
    },
};

</script>
